import { CSSProperties, PropsWithChildren } from 'react'
import css from './textField.module.css'

type TypeField = 'text' | 'link'

type Props = {
  header: string
  contentStyle?: CSSProperties
  style?: CSSProperties
  type?: TypeField
  link?: string
}

const TextField = ({ header, type = 'text', link, contentStyle, style, children }: PropsWithChildren<Props>) => {
  return (
    <div className={css.wrapper} style={style}>
      <h2 className='text--secondary text--body-m'>{header}</h2>
      {type === 'link' ? (
        <a href={link} className='text--body-m text--blue' style={contentStyle}>
          {children}
        </a>
      ) : (
        <p className='text--body-m text--primary' style={contentStyle}>
          {children}
        </p>
      )}
    </div>
  )
}

export default TextField
